import React, {Component} from 'react';
import axios from 'axios';
import { store } from 'react-notifications-component';
import { FiHome, FiCalendar, FiClock, FiDollarSign, FiEye, FiPieChart, FiSettings, FiSliders, FiUser, FiImage, FiPower, FiFileText, FiActivity, FiPaperclip, FiCreditCard } from "react-icons/fi";
import inicio from '../tools/images/inicio.png';
import sedes from '../tools/images/sedes.png';
import convenios from '../tools/images/convenios.png';
import horarios from '../tools/images/horarios.png';
import reportes from '../tools/images/reporte.png';
import ico from '../tools/images/medicall24logo.png';
import '../tools/css/Sidebar.css';
import { Alert } from 'react-bootstrap';


const ApiURL=process.env.REACT_APP_API_URL;
var Institution =sessionStorage.getItem('institution');
var Avatar =process.env.REACT_APP_API_URL+"/api/Files?path="+sessionStorage.getItem('avatar');
var mensaje='';



class Sidebar_profesional extends Component  {

  constructor(props) {
    super(props)
    this.state = {
      conteoCitasPendientes: 0
    }
  }

  componentDidMount() {
    this.cargarConteoCitasPendientes()
  }

  /**
   * Mismos endpoints que usa Citas.js en Citas_solicitadas/Citas_enproceso
   * (soli_pendientes/soli_proceso), para avisar en el sidebar cuántas
   * solicitudes o citas en proceso hay, aunque el usuario esté navegando
   * en otra ruta distinta a /citas_profesional.
   */
  cargarConteoCitasPendientes() {
    Promise.all([
      axios.get(ApiURL + "/api/Citas/GetRequestAppointment").then((response) => response.data.data.length).catch(() => 0),
      axios.get(ApiURL + "/api/Citas/ListPending").then((response) => response.data.data.length).catch(() => 0)
    ]).then(([pendientes, proceso]) => {
      const total = (pendientes > 0 ? pendientes : 0) + (proceso > 0 ? proceso : 0)
      this.setState({ conteoCitasPendientes: total })
    })
  }

  esRutaActiva = (ruta) => {
    return window.location.pathname === ruta;
  }

  esGrupoActivo = (rutas) => {
    return rutas.includes(window.location.pathname);
  }

   render(){

    const grupoFacturacionActivo = this.esGrupoActivo(['/tablero_RDA', '/facturacion', '/cuentas_cobro']);
    const grupoReportesActivo = this.esGrupoActivo(['/consultas_programadas', '/informes_facturas', '/anexos_institucion', '/reporte_facturacion']);
    const grupoConfigActivo = this.esGrupoActivo(['/ajustes', '/perfil', '/publicaciones']);

    return (

  <aside className="main-sidebar sidebar-dark-primary elevation-4">
  {/* Brand Logo */}
  <a href="/inicio_profesional" className="brand-link" id="item_ips">
    <img src={Avatar} alt="Logo" className="brand-image img-circle elevation-4" onError={(e) => { e.target.onerror = null; e.target.src = ico; }} />
    <span title={(Institution||'').toUpperCase()} className="brand-text font-weight-light">{(Institution||'').toUpperCase()}</span>
  </a>
  {/* Sidebar */}
  <div id="sidebar_personalizado" className="sidebar">
   
    {/* Sidebar Menu */}
    <nav className="mt-2">
      <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}
        <li className="nav-item">
          <a href="/inicio_profesional" className={`nav-link${this.esRutaActiva('/inicio_profesional') ? ' activo' : ''}`}>
            <FiHome className="nav-icon" />
            <p>Inicio
            </p>
          </a>
        </li>

        <li className="nav-item">
          <a href="/citas_profesional" className={`nav-link${this.esRutaActiva('/citas_profesional') ? ' activo' : ''}`}>
          <FiCalendar className="nav-icon" />
            <p>
              Asignación de citas
              {this.state.conteoCitasPendientes > 0 ? <span className="right badge badge-danger">{this.state.conteoCitasPendientes}</span> : null}
            </p>
          </a>
        </li>

        <li className="nav-item">
          <a href="/agenda_profesional" className={`nav-link${this.esRutaActiva('/agenda_profesional') ? ' activo' : ''}`}>
          <FiClock className="nav-icon" />
            <p>
              Agenda
            </p>
          </a>
        </li>

        <li className={`nav-item has-treeview${grupoFacturacionActivo ? ' menu-open' : ''}`}>
          <a href="#" className={`nav-link${grupoFacturacionActivo ? ' activo-grupo' : ''}`}>
            <FiDollarSign className="nav-icon" />
            <p>
              Facturación - IHCE
              <i className="fas fa-angle-left right" />
            </p>
          </a>
          <ul className="nav nav-treeview">
            <li className="nav-item">
              <a href="/tablero_RDA" className={`nav-link${this.esRutaActiva('/tablero_RDA') ? ' activo' : ''}`}>
              <FiEye className="nav-icon" />
                <p>IHCE</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/facturacion" className={`nav-link${this.esRutaActiva('/facturacion') ? ' activo' : ''}`}>
                <FiDollarSign className="nav-icon" />
                <p>Facturación</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/cuentas_cobro" className={`nav-link${this.esRutaActiva('/cuentas_cobro') ? ' activo' : ''}`}>
                <FiCreditCard className="nav-icon" />
                <p>Cuentas de cobro</p>
              </a>
            </li>

          </ul>
        </li>
        
      
        
        <li className="nav-header">OPCIONES</li>  

        <li className={`nav-item has-treeview${grupoReportesActivo ? ' menu-open' : ''}`}>
          <a href="#" className={`nav-link${grupoReportesActivo ? ' activo-grupo' : ''}`}>
            <FiFileText className="nav-icon" />
            <p>
              Reportes e informes
              <i className="fas fa-angle-left right" />
            </p>
          </a>
          <ul className="nav nav-treeview">
            <li className="nav-item">
              <a href="/anexos_institucion" className={`nav-link${this.esRutaActiva('/anexos_institucion') ? ' activo' : ''}`}>
                <FiPaperclip className="nav-icon" />
                <p>Anexos</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/informes_facturas" className={`nav-link${this.esRutaActiva('/informes_facturas') ? ' activo' : ''}`}>
                <FiPieChart className="nav-icon" />
                <p>Atenciones con cargos</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/consultas_programadas" className={`nav-link${this.esRutaActiva('/consultas_programadas') ? ' activo' : ''}`}>
              <FiActivity className="nav-icon" />
                <p>Reporte de consultas</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/reporte_facturacion" className={`nav-link${this.esRutaActiva('/reporte_facturacion') ? ' activo' : ''}`}>
                <FiDollarSign className="nav-icon" />
                <p>Reporte de facturación</p>
              </a>
            </li>

          </ul>
        </li>  

        <hr></hr>    
        
        <li className={`nav-item has-treeview${grupoConfigActivo ? ' menu-open' : ''}`}>
          <a href="#" className={`nav-link${grupoConfigActivo ? ' activo-grupo' : ''}`}>
            <FiSettings className="nav-icon" />
            <p>
              Configuración
              <i className="fas fa-angle-left right" />
            </p>
          </a>
          <ul className="nav nav-treeview">
          <li className="nav-item">
              <a href="/ajustes" className={`nav-link${this.esRutaActiva('/ajustes') ? ' activo' : ''}`}>
                <FiSliders className="nav-icon" />
                <p>Ajustes</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/perfil" className={`nav-link${this.esRutaActiva('/perfil') ? ' activo' : ''}`}>
                <FiUser className="nav-icon" />
                <p>Perfil</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/publicaciones" className={`nav-link${this.esRutaActiva('/publicaciones') ? ' activo' : ''}`}>
                <FiImage className="nav-icon" />
                <p>Publicaciones</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/" onClick={()=> sessionStorage.clear()} className="nav-link">
              <FiPower className="nav-icon" />
                <p>Cerrar sesión</p>
              </a>
            </li>
          </ul>
        </li>
              
       
        
        
       
       
        
      </ul>
    </nav>
    {/* /.sidebar-menu */}
  </div>
  {/* /.sidebar */}

</aside>







    )
  }

}

export default Sidebar_profesional;